<template>
  <span class="hotkey--root  text-monospace"><span v-if="command">{{commandKey}} + </span><span v-if="shift">Shift + </span><slot></slot></span>
</template>

<script>
  export default {
    props:
      {
        shift:Boolean,
        command: Boolean,
      },
    name: 'hotkey.component',
    computed: {
      commandKey () {
        // todo return control on windows
        return 'Command'
      },
    },
  }
</script>

<style scoped>
.hotkey--root {
  display: inline-block;
  min-width: 32px;
  text-align: center;
  border: 1px solid #1A1A1A;
  background-color: rgb(221, 221, 221);
}
</style>